module.exports = __webpack_public_path__ + "img/04攤位活動.e4d06a60.png";